import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCcWDwGS3owTcuMpqNm-k55_5Idrq6xbqM",
  authDomain: "fixnmoreoh.firebaseapp.com",
  projectId: "fixnmoreoh",
  storageBucket: "fixnmoreoh.firebasestorage.app",
  messagingSenderId: "248761260096",
  appId: "1:248761260096:web:042e0a580208d4e6c627a5"
};

const app = initializeApp(firebaseConfig);

export const db = getDatabase(app);